import Sidebar from "../components/Sidebar";
import StatisticsReport from "../components/StatisticsReport";

export default function Statistics() {
  return <StatisticsReport Sidebar={Sidebar} />;
}
